import styled from 'styled-components';

const ReturnCardContainer = styled.div`
  position: ${(props) => props.s.position || 'static'};
  display: ${(props) => props.s.display || 'table-cell'};
  box-sizing: border-box;
  vertical-align: top; /* IE 11 */
  background: ${(props) => props.s.background || 'transparent'};
  min-height: ${(props) => props.s.minHeight || 'auto'};
  width: ${(props) => props.s.width || '100%'};
  border-width: ${(props) => props.s.borderWidth || '1px'};
  border-style: ${(props) => props.s.borderStyle || 'solid'};
  border-color: ${(props) => props.s.borderColor || '#ccc'};
  margin-top: ${(props) => props.s.marginTop || '0'};
  margin-right: ${(props) => props.s.marginRight || '0'};
  margin-bottom: ${(props) => props.s.marginBottom || '0'};
  margin-left: ${(props) => props.s.marginLeft || '0'};
  @media (hover) {
    &:hover {
      border-style: ${(props) => props.s.hoverBorderStyle || 'solid'};
      border-width: ${(props) => props.s.hoverBorderWidth || '1px'};
      border-color: ${(props) => props.s.hoverBorderColor || '#ccc'};
      background: ${(props) => props.s.hoverBackground || '#F6F6F6'};
    }
  }
  @media only screen and (max-width: 768px) {
    display: block;
    width: 100%;
    margin: ${({ sMobile = {} } = {}) => sMobile.margin || '20px 0 0 0'};
  }
`;

export default ReturnCardContainer;
